module.exports = __webpack_public_path__ + "static/media/173.98c9e195.jpg";